import api from '../authService/authService';

export interface CreatePaymentPayload {
  product: string;
}

export interface CreatePaymentResponse {
  checkoutUrl?: string;
  message?: string;
  changeType?: string;
  status?: string;
  [key: string]: any;
}

export const createPayment = async (
  payload: CreatePaymentPayload
): Promise<CreatePaymentResponse> => {
  try {
    const response = await api.post<CreatePaymentResponse>(
      'payments/',
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error creating payment:', error);
    throw error;
  }
};

export const cancelSubscription = async (): Promise<CreatePaymentResponse> => {
  try {
    const response = await api.get<CreatePaymentResponse>('payments/cancel');
    return response.data;
  } catch (error) {
    console.error('Error canceling subscription:', error);
    throw error;
  }
};

/** Billing/customer portal session URL (backend may return `url` or `checkoutUrl`). */
export interface CustomerPortalResponse {
  url?: string;
  checkoutUrl?: string;
  [key: string]: any;
}

export interface PaymentUsagePlanLimits {
  emailSentHistory: number;
  campaign: number | null;
  segment: number | null;
  contact: number;
  workspace: number | null;
  teamMembers: number;
}

export interface PaymentUsageResponse {
  emailSentHistory: number;
  campaignCount: number;
  segmentCount: number;
  contactCount: number;
  workspaceCount: number;
  pendingUsage: boolean;
  planLimits: PaymentUsagePlanLimits;
}

export interface CurrentPlanResponse {
  plan?: string | null;
  status?: string | null;
  planStarts?: string | null;
  planEnds?: string | null;
}

/** Values returned by `payments/current-plan` for subscription lifecycle. */
export type SubscriptionBillingStatus = 'processing' | 'active' | 'on_hold';

export function normalizeSubscriptionStatus(
  status: string | null | undefined
): SubscriptionBillingStatus {
  const normalized = status?.trim().toLowerCase();
  if (normalized === 'processing') return 'processing';
  if (normalized === 'on_hold') return 'on_hold';
  return 'active';
}

export const getCustomerPortal = async (): Promise<CustomerPortalResponse> => {
  try {
    const response = await api.get<CustomerPortalResponse>(
      'payments/customer-portal'
    );
    return response.data;
  } catch (error) {
    console.error('Error opening customer portal:', error);
    throw error;
  }
};

export const getPaymentUsage = async (): Promise<PaymentUsageResponse> => {
  try {
    const response = await api.get<PaymentUsageResponse>('payments/usage');
    return response.data;
  } catch (error) {
    console.error('Error fetching payment usage:', error);
    throw error;
  }
};

export const getCurrentPlan = async (): Promise<CurrentPlanResponse> => {
  try {
    const response = await api.get<CurrentPlanResponse>(
      'payments/current-plan'
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching current plan:', error);
    throw error;
  }
};
